<template>
  <div class="event-video">
    <video-player ref="videoPlayer" :options="playerOptions"/>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'event-video',
  props: {
    thumbnail: String,
    src: String,
  },
  components: {
    videoPlayer,
  },
  data() {
    return {
      playerOptions: {
        // component options
        start: 0,
        playsinline: true,
        fluid: true,
        // videojs options
        controlBar: {
          remainingTimeDisplay: false,
        },
        muted: true,
        playbackRates: [1.0, 1.5, 2.0],
        inactivityTimeout: 0,
        language: 'ja',
        aspectRatio: '4:3',
        sources: [{
          type: 'video/mp4',
          src: this.src,
        }],
        poster: this.thumbnail,
      },
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
    src() {
      this.player.src({ type: 'video/mp4', src: this.src });
    },
    thumbnail() {
      this.player.poster(this.thumbnail);
    },
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'
$videojs-controlbar-height: 42px

.event-video
  ::v-deep .video-js
    padding-bottom: $videojs-controlbar-height

    .vjs
      &-tech,
      &-poster
        height: calc(100% - #{$videojs-controlbar-height})

      &-loading-spinner,
      &-big-play-button
        top: calc(50% - (#{$videojs-controlbar-height} / 2))

      &-control-bar
        display: flex
        opacity: 1
</style>
